import client from '.'
import { getAuthHeaders } from 'utils/requests'

const updatePortalPassword = async (clientId, password) => {
  const { data } = await client.patch(
    `/${clientId}/portal-password`,
    { password },
    { headers: getAuthHeaders() }
  )

  return data
}

export default updatePortalPassword
